export const FormBuilderRouteNames = {
  default: 'form-builder-v2',
  main: 'form-builder-main-v2',
  analyze: 'form-builder-analyze-v2',
  submissions: 'form-builder-submissions-v2',
  manage: 'form-builder-manage',
  integrate: 'form_builder_integrate-v2',
}
